import SectionHeading from "@/components/base/SectionHeading";
import { rankings } from "@/mocks/home";

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热门排行"
            title="本周热门榜：按口碑与讨论热度排序"
            description="榜单综合观看完成度、收藏与讨论热度形成参考值，并标注了各自的看点，方便你根据自己的口味取舍。"
          />
          <p className="shrink-0 font-label text-xs text-foreground-500">
            更新于每周一 · 共收录 {rankings.length} 部代表作品
          </p>
        </div>

        <ol className="mt-10 space-y-3 md:space-y-4">
          {rankings.map((item) => (
            <li
              key={item.rank}
              className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5"
            >
              <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-6">
                <div className="flex items-center gap-4 md:w-52 md:shrink-0">
                  <span
                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg font-heading text-xl font-bold ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-0.5 text-xs text-foreground-500">
                      {item.region} · {item.year}
                    </p>
                  </div>
                </div>

                <div className="md:flex-1">
                  <p className="text-sm leading-relaxed text-foreground-700">{item.reason}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs font-medium text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center gap-4 border-t border-background-200 pt-3 md:w-36 md:shrink-0 md:flex-col md:items-end md:border-t-0 md:pt-0">
                  <div className="flex items-center gap-2 md:flex-col md:items-end md:gap-0.5">
                    <span className="font-heading text-xl font-bold text-accent-700">
                      {item.rating.toFixed(1)}
                    </span>
                    <span className="text-xs text-foreground-500">综合评分</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-chat-3-line mr-1" aria-hidden="true"></i>
                    {item.reviews} 条讨论
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}